import { Select } from "antd";
import UserTag from "components/user-tag/user-tag";
import { AcceptanceStatus } from "constants/index";
import { useProjectParticipants } from "hooks/project-participants";
import { useMemo } from "react";

const { Option } = Select;

type Props = {
  value?: any;
  notFoundContent?: any;
  onChange?: (value: any, option: any) => void;
  disabled?: boolean;
  selectedCompanyFieldId: string;
  companyNotFoundContent?: string;
  projectParticipantType: "designReviewers" | "submitterUsers";
};

function DependedCompanyUserDropdownComponent(props: Props) {
  const {
    value,
    notFoundContent,
    onChange,
    disabled,
    selectedCompanyFieldId,
    companyNotFoundContent = "First select a Responsible Contractor",
    projectParticipantType
  } = props;
  const { projectParticipants } = useProjectParticipants();

  const responsibleDesigners = useMemo(() => {
    if (!projectParticipants) return undefined;
    const arr = projectParticipants[projectParticipantType]?.filter(
      (user: any) =>
        selectedCompanyFieldId &&
        user &&
        user?.company?.vendor_id === selectedCompanyFieldId
    );
    return arr;
  }, [projectParticipantType, projectParticipants, selectedCompanyFieldId]);

  if (!selectedCompanyFieldId)
    return (
      <div className="flex justify-center items-center h-full w-full">
        <Select
          disabled
          allowClear
          options={[
            {
              label: (
                <div className="flex items-center text-ciq-red-800 text-xs h-full">
                  {companyNotFoundContent}
                </div>
              ),
              value: 1
            }
          ]}
          value={1}
        />
      </div>
    );

  return (
    <Select
      className="w-full"
      loading={!projectParticipants?.dataLoaded}
      value={value || undefined}
      allowClear
      onChange={onChange}
      showSearch
      filterOption={(inputValue, option: any) =>
        option.label.toLowerCase().includes(inputValue.toLowerCase())
      }
      optionFilterProp="label"
      notFoundContent={notFoundContent}
      disabled={disabled}
      data-testid="index-select-company-user"
    >
      {responsibleDesigners.map((user: any) => {
        if (
          (user.status_id === AcceptanceStatus.DEACTIVATED &&
            user.id !== value?.toString()) ??
          ""
        )
          return "";

        const selectedAndInactive =
          (user.status_id === AcceptanceStatus.DEACTIVATED &&
            user.id === value?.toString()) ??
          "";

        return (
          <Option
            key={user.id}
            value={user.id}
            label={`${user.first_name} ${user.last_name} ${user?.company?.name}`}
            firstName={user.first_name}
            lastName={user.last_name}
            company={user?.company}
            className={selectedAndInactive ? "hidden" : ""}
          >
            {user.status_id === AcceptanceStatus.DEACTIVATED && (
              <div className="absolute flex w-full items-center justify-end pr-3 -mt-[1px]">
                <UserTag label="Inactive" />
              </div>
            )}
            <div>
              {user.first_name} {user.last_name}
            </div>
            <div className="text-sm text-gray-500">{user?.company?.name}</div>
          </Option>
        );
      })}
    </Select>
  );
}

export default DependedCompanyUserDropdownComponent;
